export const API_MENU_TRANSLATIONS_FIELDS = [
    'menu.translations.id',
    'menu.translations.languages_id',
    'menu.translations.name',
    'menu.translations.link'
];
export const API_PROJECT_LINK_MENU_TRANSLATIONS_FIELDS = [
    'project_link.translations.id',
    'project_link.translations.languages_id',
    'project_link.translations.name',
    'project_link.translations.link'
];
